import type {ReactElement} from 'react';
import React from 'react';
import {Modal} from '@Components/modal';
import {openPanelInModal, updatePanelPropsForModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import {useAppSelector} from '@/hooks';
import {triggerResumablePanelOpening} from '@Components/modal/modal.library';
import type {DownloadPanelProps} from '@Components/download-panel/download-panel';
import {GA4EventName, GA4EventParamName, trackPosterBuilderGA4Events} from '@Libraries/ga-events';

const PANEL_ID = 'download-panel-wrapper';

export default function DownloadModal(): ReactElement {
  const modalData = useAppSelector((state) => {
    return state.modals.modalsHashmap[MODALS_IDS.DOWNLOAD_MODAL];
  });
  const height = 'fit-content';

  return (
    <Modal
      isBottomSheetNonBlocking={!!modalData.panelProps.isOpenedInPrintShop}
      modalWidth={'410px'}
      modalId={MODALS_IDS.DOWNLOAD_MODAL}
      panelId={PANEL_ID}
      modalHeight={height}
      isBottomSheetOnMobile
    >
      <LazyPanel
        panelDirectoryName={PANEL_ID}
        panelProps={{
          ...modalData.panelProps,
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const openNewDownloadModal = (props: DownloadPanelProps): void => {
  const panelProps = {
    ...props,
    id: PANEL_ID,
    isOpenedInModal: true,
    hideOnClose: true,
  };

  let sourceForEvent = 'editor';
  if (props.isOpenedInPrintShop) {
    sourceForEvent = 'print-shop';
  } else {
    if (!props.isOpenedInEditor) {
      sourceForEvent = 'mystuff';
    }
  }

  trackPosterBuilderGA4Events(GA4EventName.NEW_DOWNLOAD_DIALOG_OPEN, {[GA4EventParamName.SOURCE]: sourceForEvent});
  triggerResumablePanelOpening(PANEL_ID, () => {
    window.PMW.redux.store.dispatch(
      openPanelInModal({
        modalId: MODALS_IDS.DOWNLOAD_MODAL,
        panelProps: panelProps,
      })
    );
  });

  window.PMW.redux.store.dispatch(updatePanelPropsForModal({modalId: MODALS_IDS.DOWNLOAD_MODAL, panelProps: panelProps}));
};
